import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BorderouComponent } from './borderou.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { AddBorderouComponent } from './add-borderou/add-borderou.component';
import { ViewBorderouComponent } from './view-borderou/view-borderou.component';

@NgModule({
    declarations: [
        BorderouComponent,
        AddBorderouComponent,
        ViewBorderouComponent,
    ],
    imports: [CommonModule, MaterialModule, ReactiveFormsModule, FormsModule],
    exports: [BorderouComponent],
})
export class BorderouModule { }
